import { ResultEntry } from '~/../api/common.types';
import Heading from '~/components/common/Heading';
import { useGameContext } from '~/contextProviders/GameContextProvider';
import { getAttack, wasAttackSelectd } from '~/utils/utils';

function BattleResultElements({
  victor,
  ownerCombat,
  opponentCombat,
}: {
  victor: number;
  ownerCombat: ResultEntry;
  opponentCombat: ResultEntry;
}) {
  let status = '';
  if (victor === ownerCombat.warrior.id) {
    status = 'defeated';
  } else if (victor !== undefined && victor !== ownerCombat.warrior.id) {
    status = 'lost to';
  } else if (victor === undefined) {
    status = 'tied with';
  }

  const ownerAttack = getAttack(ownerCombat);
  const opponentAttack = getAttack(opponentCombat);

  const ownerAttackSelected = wasAttackSelectd(ownerCombat);
  const opponentAttackSelected = wasAttackSelectd(opponentCombat);

  const ownerImage = ownerAttack ? ownerAttack.toLowerCase() : 'transparent';
  const opponentImage = opponentAttack ?
    opponentAttack.toLowerCase() :
    'transparent';
  const { tournamentParam } = useGameContext();
  const isPeaceful = tournamentParam === 'peaceful';

  return (
    <div className="battle-result__attacks">
      <div
        className="attack-status__attack"
        data-id={ownerAttack.toLowerCase()}
      >
        <img
          src={
            isPeaceful ?
              `/img/peaceful/${ownerImage}.png` :
              `/img/syndicate.${ownerImage}.png`
          }
          title={ownerAttack}
          alt={ownerAttack || 'attack image'}
          className="warrior__attack__image"
        />
        <div className="attack-choice">
          {ownerAttack ? ownerAttack : 'No auto select'}{' '}
        </div>
        {ownerAttack && !ownerAttackSelected && (
          <div className="attack-choice">{'(auto selected)'}</div>
        )}
      </div>
      <h4 className="attack-status">{status}</h4>
      <div
        className="attack-status__attack"
        data-id={opponentAttack.toLowerCase()}
      >
        <img
          src={
            isPeaceful ?
              `/img/peaceful/${opponentImage}.png` :
              `/img/syndicate.${opponentImage}.png`
          }
          title={opponentAttack}
          alt={opponentAttack || 'attack image'}
          className="warrior__attack__image"
        />
        <div className="attack-choice">
          {opponentAttack ? opponentAttack : 'No auto select'}{' '}
        </div>
        {opponentAttack && !opponentAttackSelected && (
          <div className="attack-choice">{'(auto selected)'}</div>
        )}
      </div>
    </div>
  );
}

export default function BattleResultStatus({
  warrior,
  victor,
  combat,
  announce,
}) {
  const ownerCombat = combat.find(
    (attack) => attack.warrior.id === warrior.warrior_id
  );
  const opponentCombat = combat.find(
    (attack) => attack.warrior.id !== warrior.warrior_id
  );

  return (
    <div className="battle-result-status">
      <div className="battle-result-status__body">
        {victor === warrior.warrior_id && (
          <>
            <div className="battle-result-status__text">
              <img
                src="/img/icn.level-up.png"
                alt="Level Up"
                className="battle-result-status__icon"
              />
              <Heading level={4}>You Advanced to the next round</Heading>
            </div>
            <div className="battle-result-image__container">
              <img
                src="/img/you-win.png"
                alt="You Win"
                className="battle-result-status__headline battle-result-status__headline--desktop"
              />
              <img
                src="/img/win-mobile.png"
                srcSet="/img/win-mobile.png 1x, /img/win-mobilex2.png 2x"
                alt="You Win"
                className="battle-result-status__headline battle-result-status__headline--mobile"
              />
            </div>
            {announce && (
              <audio autoPlay>
                <source src="/you-win.mp3" type="audio/mpeg" />
              </audio>
            )}
          </>
        )}
        {victor !== undefined && victor !== warrior.warrior_id && (
          <>
            <div className="battle-result-status__text">
              <Heading level={4}>&nbsp;</Heading>
            </div>
            <div className="battle-result-image__container">
              <img
                src="/img/you-lose.png"
                alt="You Lose"
                className="battle-result-status__headline battle-result-status__headline--desktop"
              />
              <img
                src="/img/lose-mobile.png"
                srcSet="/img/lose-mobile.png 1x, /img/lose-mobilex2.png 2x"
                alt="You Lose"
                className="battle-result-status__headline battle-result-status__headline--mobile"
              />
            </div>
            {announce && (
              <audio autoPlay>
                <source src="/you-lose.mp3" type="audio/mpeg" />
              </audio>
            )}
          </>
        )}
        {victor === undefined && (
          <>
            <div className="battle-result-status__text">
              <Heading level={4}>&nbsp;</Heading>
            </div>
            <div className="battle-result-image__container">
              <img
                src="/img/draw.png"
                alt="Draw"
                className="battle-result-status__headline"
              />
            </div>
          </>
        )}
        <BattleResultElements
          victor={victor}
          ownerCombat={ownerCombat}
          opponentCombat={opponentCombat}
        />
      </div>
    </div>
  );
}
